import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard implements CanActivate {
  constructor(
    private readonly keycloak: KeycloakService,
  ) {}

  public async canActivate(): Promise<boolean | UrlTree> {
    const isLoggedIn = this.keycloak.isLoggedIn();

    if (isLoggedIn) {
      return false;
    }

    return true;
  }
}
